//! Opens the worksheet AutoFilter dropdown from the header-row buttons.

import { hasPermissionToEditFile } from '@/app/actions';
import { ContextMenuType, type ContextMenuState } from '@/app/atoms/contextMenuAtom';
import { events } from '@/app/events/events';
import { content } from '@/app/gridGL/pixiApp/contentInstance';
import * as gridSettings from '@/app/gridGL/pixiApp/gridSettings';
import type { FederatedPointerEvent, Point } from 'pixi.js';

export class PointerSheetAutoFilter {
  cursor: string | undefined;

  pointerMove = (world: Point): boolean => {
    const buttons = content.cellsSheets.current?.sheetAutoFilterButtons;
    if (!buttons) {
      this.cursor = undefined;
      return false;
    }
    const over = buttons.pointerMove(world);
    this.cursor = buttons.tableCursor;
    return over;
  };

  pointerDown = (world: Point, event: FederatedPointerEvent): boolean => {
    if (event.button === 2) return false;
    if (!hasPermissionToEditFile(gridSettings.getPermissions())) return false;

    const buttons = content.cellsSheets.current?.sheetAutoFilterButtons;
    if (!buttons) return false;
    const columnIndex = buttons.pointerDown(world);
    if (columnIndex === undefined) return false;

    const previous = gridSettings.getContextMenu() as ContextMenuState;
    events.emit('contextMenu', {});
    if (previous.type === ContextMenuType.SheetColumnFilter && previous.selectedColumn === columnIndex) {
      return true;
    }

    events.emit('contextMenu', {
      type: ContextMenuType.SheetColumnFilter,
      world,
      selectedColumn: columnIndex,
    });
    return true;
  };
}
